import RouteTemplate from 'ember-route-template';
import pageTitle from 'ember-page-title/helpers/page-title';
import { LinkTo } from '@ember/routing';
import { link } from 'ember-link';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import Container from 'frontend/components/container';
import Header from 'frontend/components/header';
import Link from 'frontend/components/link';
import Section from 'frontend/components/section';
import SectionFooter from 'frontend/components/section-footer';
import Sections from 'frontend/components/sections';

import styles from './subscribe-success.css';

export default RouteTemplate(
  <template>
    {{pageTitle "Success"}}

    <Container>
      <:header>
        <Header>
          <LinkTo
            data-test-menu-link
            aria-label="Show menu"
            @route="menu"
          >{{svgJar "btn-menu"}}</LinkTo>
        </Header>
      </:header>
      <:main>
        <Sections>
          <Section class={{styles.success}}>
            <img
              alt="An explosive success!"
              src="/images/illustrations/success.svg"
            />
            {{#let (link "authenticated") as |l|}}
              <Link
                class={{styles.btn}}
                href={{l.url}}
                {{on "click" l.open}}
                data-test-visit-dashboard
              >Visit dashboard</Link>
            {{/let}}
          </Section>
          <SectionFooter />
        </Sections>
      </:main>
    </Container>
  </template>
);
